import { SelectChangeEvent } from "@mui/material"
import { useMemo, useState } from "react"
import { IFetchOpportunitiesFilters } from "src/services/api/opportunities"

export const useOpportunitiesFilters = () => {
    // Estados para os filtros
    const [sortDirection, setSortDirection] = useState<string>('');
    const [clientsImpactedFilter, setClientsImpactedFilter] = useState<string>('');
    const [validityFilter, setValidityFilter] = useState<string>('');
    
    // Opções para ordenar por
    const sortOptions = [
        { value: '', label: 'Ordenar por' },
        { value: 'DESC', label: 'Mais recente' },
        { value: 'ASC', label: 'Mais antigos' },
    ];
    
    // Opções para filtro de clientes impactados
    const clientsImpactedOptions = [
        { value: '', label: 'Filtro de clientes impactados' },
        { value: '1-10', label: '1 a 10 clientes' },
        { value: '10-30', label: '10 a 30 clientes' },
        { value: '30-50', label: '30 a 50 clientes' },
        { value: '50-70', label: '50 a 70 clientes' },
        { value: '70-100', label: '70 a 100 clientes' },
        { value: '100+', label: 'Mais de 100 clientes' },
    ];
    
    // Opções para filtro de validade
    const validityFilterOptions = [
        { value: '', label: 'Filtro de validade' },
        { value: '1-10', label: '1 a 10 dias' },
        { value: '10-30', label: '10 a 30 dias' },
        { value: '30-90', label: '30 a 90 dias' },
        { value: '90-180', label: '90 a 180 dias' },
        { value: '180+', label: 'Mais de 180 dias' },
    ];
    
    // Construir objeto de filtros baseado nos estados
    const filters = useMemo<IFetchOpportunitiesFilters | undefined>(() => {
        const filterObj: IFetchOpportunitiesFilters = {};
        
        if (sortDirection) {
            filterObj.sort_direction = sortDirection as 'ASC' | 'DESC';
        }
        
        if (clientsImpactedFilter) {
            if (clientsImpactedFilter === '1-10') {
                filterObj.min_clients_impacted = 1;
                filterObj.max_clients_impacted = 10;
            } else if (clientsImpactedFilter === '10-30') {
                filterObj.min_clients_impacted = 10;
                filterObj.max_clients_impacted = 30;
            } else if (clientsImpactedFilter === '30-50') {
                filterObj.min_clients_impacted = 30;
                filterObj.max_clients_impacted = 50;
            } else if (clientsImpactedFilter === '50-70') {
                filterObj.min_clients_impacted = 50;
                filterObj.max_clients_impacted = 70;
            } else if (clientsImpactedFilter === '70-100') {
                filterObj.min_clients_impacted = 70;
                filterObj.max_clients_impacted = 100;
            } else if (clientsImpactedFilter === '100+') {
                filterObj.min_clients_impacted = 100;
            }
        }
        
        if (validityFilter) {
            if (validityFilter === '1-10') {
                filterObj.min_days = 1;
                filterObj.max_days = 10;
            } else if (validityFilter === '10-30') {
                filterObj.min_days = 10;
                filterObj.max_days = 30;
            } else if (validityFilter === '30-90') {
                filterObj.min_days = 30;
                filterObj.max_days = 90;
            } else if (validityFilter === '90-180') {
                filterObj.min_days = 90;
                filterObj.max_days = 180;
            } else if (validityFilter === '180+') {
                filterObj.min_days = 180;
            }
        }
        
        // Retorna undefined se não houver filtros para evitar requisições desnecessárias
        if (Object.keys(filterObj).length === 0) {
            return undefined;
        }
        
        return filterObj;
    }, [sortDirection, clientsImpactedFilter, validityFilter]);
    
    const handleSortChange = (event: SelectChangeEvent<unknown>) => {
        setSortDirection(event.target.value as string);
    };
    
    const handleClientsImpactedChange = (event: SelectChangeEvent<unknown>) => {
        setClientsImpactedFilter(event.target.value as string);
    };
    
    const handleValidityFilterChange = (event: SelectChangeEvent<unknown>) => {
        setValidityFilter(event.target.value as string);
    };
    
    return {
        // Estados
        sortDirection,
        clientsImpactedFilter,
        validityFilter,
        // Opções
        sortOptions,
        clientsImpactedOptions,
        validityFilterOptions,
        // Filtros construídos
        filters,
        // Handlers
        handleSortChange,
        handleClientsImpactedChange,
        handleValidityFilterChange,
    };
};
